import { ConsoleLogger } from '@mimir/common/util/logging';
import { parseOrNull } from '@mimir/common/util/general';

export const SESSION_STORAGE_KEYS = {
  LAST_SELECTED_STAGE_GLOBAL_LOGIN: 'lastSelectedStageGlobalLogin',
  LAST_ENTERED_IDENTITY_GLOBAL_LOGIN: 'lastEnteredIdentityGlobalLogin',

  LOG_OUT_REDIRECT: 'logOutRedirect'
} as const;

export type SessionStorageKey = typeof SESSION_STORAGE_KEYS[keyof typeof SESSION_STORAGE_KEYS];

const logger = new ConsoleLogger();

function setSessionStorage<T>(key: SessionStorageKey | string, value: T | null): void {
  try {
    if (value === null) {
      sessionStorage.removeItem(key);
      return;
    }
    const serializedValue = JSON.stringify(value);
    sessionStorage.setItem(key, serializedValue);
  } catch (error) {
    logger.error(`Failed to set session storage key "${key}": ${error}`);
  }
}

function getSessionStorage<T>(key: SessionStorageKey | string): T | null {
  try {
    const value = sessionStorage.getItem(key);
    return parseOrNull<T>(logger, value);
  } catch (error) {
    logger.error(`Failed to get session storage key "${key}": ${error}`);
    return null;
  }
}

export function getLogOutRedirectSession(): string | null {
  return getSessionStorage<string>(SESSION_STORAGE_KEYS.LOG_OUT_REDIRECT);
}

export function setLogOutRedirectSession(redirect: string | null): void {
  setSessionStorage<string | null>(SESSION_STORAGE_KEYS.LOG_OUT_REDIRECT, redirect);
}
